import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class NegaraService {
  private apiUrl = environment.apiUrl+'/negara';

  private apiUrlmulti = environment.apiUrl+'/multinegara';


  constructor(private http: HttpClient) { }

  getData(): Observable<any> {
    return this.http.get('/api/negara');
  }


  saveMultipleData(data: any[]): Observable<any> {
    return this.http.post('/api/multinegara', data); // Mengirim array objek
  }
}
